<template>
  <select2
    :required="!atLeastSectorSelected"
    :options="options"
    v-model="selected"
    placeholder="Funding Need"
    parent="funding"
  >
  </select2>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Select2 from "./Select2Wrapper.vue";

export default {
  name: "InvestorTypeDropDown",
  components: {
    select2: Select2
  },
  data: function() {
    return {
      selected: "",
      options: [
        {
          id: 0,
          text: "All"
        },
        {
          id: 1,
          text: "0-25k (USD)"
        },
        {
          id: 2,
          text: "25k-75k (USD)"
        },
        {
          id: 3,
          text: "75k-150k (USD)"
        },
        {
          id: 4,
          text: "150k-500k (USD)"
        },
        {
          id: 5,
          text: "500k+ (USD)"
        }
      ]
    };
  },
  methods: {
    ...mapMutations({
      setFundingNeed: "setFundingNeed"
    })
  },
  computed: {
    ...mapGetters([
      "providerTypes",
      "selectedDropdownSector",
      "fundingNeed",
      "selectedDropdownFemaleFocus"
    ]),
    atLeastSectorSelected() {
      return this.selectedDropdownSector != undefined;
    }
  },
  watch: {
    selected: function(value) {
      this.setFundingNeed(value);
    }
  },
  mounted() {
    if (this.fundingNeed) {
      this.selected = this.fundingNeed;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/SearchBar/FundingNeedDropDown.vue